import { isEmptyImportValue } from './isEmptyImportValue'
import type { EnumResolveEntry, ImportApplyWarning } from './types'

export function applyEnumResolveToRow(
  row: Record<string, unknown>,
  enumAttrs: string[],
  enumMaps: Record<string, Record<string, EnumResolveEntry>>,
  rowNum: number,
): { row: Record<string, unknown>; warnings: ImportApplyWarning[] } {
  let nextRow = { ...row }
  const warnings: ImportApplyWarning[] = []

  for (const attr of enumAttrs) {
    const cell = nextRow[attr]
    if (isEmptyImportValue(cell)) continue

    const key = String(cell).trim()
    const resolveMap = enumMaps[attr] ?? {}
    const hit = resolveMap[key]

    if (!hit || hit.status === 'missing') {
      nextRow = { ...nextRow, [attr]: '' }
      warnings.push({
        row: rowNum,
        attr,
        message: `Missing enum match for "${key}" on ${attr}`,
      })
      continue
    }

    nextRow = { ...nextRow, [attr]: hit.name ?? '' }
    if (hit.status === 'ambiguous') {
      warnings.push({
        row: rowNum,
        attr,
        message: `Ambiguous enum match for "${key}" on ${attr}`,
      })
    }
  }

  return { row: nextRow, warnings }
}
